import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { sortUserAchievementsByThreshold } from "common/sort-user-achievements";

// Key of the SDK's user achievements query (GET_USER_ACHIEVEMENTS_MESSAGE_TYPE
// in @leagueplatform/rewards-api, not a direct dependency of this app).
const USER_ACHIEVEMENTS_QUERY_KEY = "get_user_achievements";

// <LeagueProvider> mounts its own QueryClientProvider, so the app's client is
// never the one the SDK's achievements pages read from. Register against the
// client in context instead. This runs during render because the SDK's
// `useQuery` picks up query defaults when its observer is created, which is
// before any effect here could run; mount it as the first child of
// <LeagueProvider> so it renders ahead of the routes.
export const UserAchievementsOrdering = () => {
  const queryClient = useQueryClient();

  useState(() =>
    queryClient.setQueryDefaults([USER_ACHIEVEMENTS_QUERY_KEY], {
      select: sortUserAchievementsByThreshold,
    })
  );

  return null;
};
